import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import DtoAccountStatistic from '../../dto/DtoAccountStatistic'
import AccountAccessChartPanel from './charts/AccountAccessChartPanel'
import AccountStationStatisticsPanel from './statistic/AccountStationStatisticsPanel'
import AccountStatisticsPanel from './statistic/AccountStatisticsPanel'
import AccountUsageStatisticsPanel from './statistic/AccountUsageStatisticsPanel'
import { Grid, Stack } from '@mui/material'

class StatisticAccountPanel extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        if (this.props.accountStatistics.length) {
            return (
                <div className='row no-margin'>
                    <Stack spacing={1} sx={{ px: '0.75rem' }}>
                        <Grid container>
                            <Grid size={8}>
                                <AccountAccessChartPanel/>
                            </Grid>
                            <Grid size={4}>
                                <AccountStatisticsPanel/>
                            </Grid>
                        </Grid>
                        <AccountUsageStatisticsPanel/>
                        <AccountStationStatisticsPanel/>
                    </Stack>
                </div>
            )
        }
        return null
    }
}

StatisticAccountPanel.propTypes = {
    accountStatistics: PropTypes.arrayOf(PropTypes.instanceOf(DtoAccountStatistic)),
}

const mapStateToProps = (store) => {
    return {
        accountStatistics: store.AccountReducer.accountStatistics,
    }
}
export default connect(mapStateToProps)(StatisticAccountPanel)
